// Macro-settori e skill specifiche per il Canton Ticino
export const SETTORI_SKILLS = {
  "Ristorazione": {
    icon: "🍽️",
    skills: [
      "Chef de cuisine", "Sous chef", "Chef de partie", "Commis di cucina", "Aiuto cuoco",
      "Pizzaiolo", "Pasticcere", "Panettiere", "Barista", "Barman/Barlady",
      "Cameriere/a", "Chef de rang", "Sommelier", "Maître", "Runner",
      "Lavapiatti", "Addetto catering", "Food & Beverage Manager"
    ]
  },
  "Edilizia": {
    icon: "🏗️",
    skills: [
      "Muratore", "Carpentiere", "Ferraiolo", "Gruista", "Escavatorista",
      "Elettricista edile", "Idraulico", "Piastrellista", "Imbianchino", "Stuccatore",
      "Posatore pavimenti", "Lattoniere", "Copritetto", "Gessatore", "Manovale",
      "Capocantiere", "Geometra di cantiere", "Addetto sicurezza cantieri"
    ]
  },
  "IT & Digital": {
    icon: "💻",
    skills: [
      "Sviluppatore Frontend", "Sviluppatore Backend", "Full Stack Developer", "Mobile Developer",
      "DevOps Engineer", "System Administrator", "Network Engineer", "Cybersecurity Analyst",
      "Data Analyst", "Data Scientist", "UX/UI Designer", "Project Manager IT",
      "Help Desk / Supporto IT", "Database Administrator", "Cloud Engineer",
      "QA Tester", "Scrum Master", "Business Analyst"
    ]
  },
  "Amministrazione & Banche": {
    icon: "🏦",
    skills: [
      "Impiegato/a amministrativo", "Segretaria/o", "Receptionist", "Contabile",
      "Addetto paghe", "Controller", "Revisore contabile", "Fiscalista",
      "Consulente bancario", "Gestore patrimoniale", "Analista finanziario", "Trader",
      "Compliance Officer", "Risk Manager", "Addetto back office", "HR Specialist",
      "Assistente di direzione", "Office Manager"
    ]
  },
  "Lusso & Orologeria": {
    icon: "⌚",
    skills: [
      "Orologiaio", "Orologiaio rhabilleur", "Incassatore di pietre", "Lucidatore",
      "Decoratore movimento", "Smaltatore", "Guillocheur", "Incisore",
      "Assemblatore movimenti", "Controllo qualità orologi", "Gioielliere", "Orafo",
      "Incastonatore", "Addetto vendite lusso", "Visual Merchandiser lusso",
      "Store Manager boutique", "Personal Shopper", "Brand Ambassador"
    ]
  },
  "Sanità": {
    icon: "🏥",
    skills: [
      "Infermiere/a", "OSS (Operatore Socio Sanitario)", "Fisioterapista", "Logopedista",
      "Tecnico di radiologia", "Tecnico di laboratorio", "Farmacista", "Assistente di farmacia",
      "Medico generico", "Medico specialista", "Dentista", "Igienista dentale",
      "Assistente di studio medico", "Segretaria medica", "Psicologo",
      "Educatore sociale", "Assistente geriatrico", "Soccorritore"
    ]
  },
  "Logistica & Trasporti": {
    icon: "🚚",
    skills: [
      "Autista patente B", "Autista patente C", "Autista patente D", "Autista bus",
      "Conducente TIR", "Corriere / Fattorino", "Magazziniere", "Carrellista",
      "Addetto spedizioni", "Coordinatore logistica", "Pianificatore trasporti",
      "Addetto dogana", "Operatore aeroportuale", "Addetto carico/scarico",
      "Responsabile magazzino", "Supply Chain Manager", "Inventory Controller"
    ]
  },
  "Vendita & Commercio": {
    icon: "🛒",
    skills: [
      "Commesso/a", "Addetto vendite", "Cassiere/a", "Store Manager",
      "Visual Merchandiser", "Promoter", "Agente di commercio", "Key Account Manager",
      "Sales Representative", "Export Manager", "E-commerce Manager", "Category Manager",
      "Buyer", "Responsabile acquisti", "Trade Marketing", "Addetto scaffali",
      "Customer Service", "Account Manager"
    ]
  },
  "Settore Pubblico": {
    icon: "🏛️",
    skills: [
      "Impiegato comunale", "Segretario comunale", "Funzionario cantonale",
      "Ufficio tecnico comunale", "Manutenzione strade", "Addetto verde pubblico",
      "Operaio forestale", "Polizia comunale", "Guardia di confine", "Vigile del fuoco",
      "Operatore ecologico", "Addetto catasto", "Archivista", "Bibliotecario",
      "Assistente sociale pubblico", "Insegnante", "Educatore asilo nido"
    ]
  },
  "Servizi alla Persona": {
    icon: "💆",
    skills: [
      "Parrucchiere/a", "Barbiere", "Estetista", "Massaggiatore/trice",
      "Nail Artist", "Make-up Artist", "Personal Trainer", "Istruttore fitness",
      "Badante", "Colf / Collaboratrice domestica", "Baby-sitter", "Dog sitter",
      "Autista privato", "Governante", "Maggiordomo", "Wedding Planner",
      "Event Planner", "Fotografo"
    ]
  },
  "Pulizie e Igiene": {
    icon: "🧹",
    skills: [
      "Addetto/a pulizie", "Pulizie uffici", "Pulizie industriali", "Pulizie condominiali",
      "Pulizie post-cantiere", "Lavaggio vetri", "Sanificazione ambienti", "Disinfezione",
      "Pulizie alberghiere", "Housekeeping", "Lavanderia", "Stireria",
      "Pulizie fine locazione", "Sgomberi e smaltimento", "Derattizzazione",
      "Disinfestazione", "Giardiniere", "Manutenzione verde"
    ]
  },
  "Traslochi e Sgomberi": {
    icon: "📦",
    skills: [
      "Traslochi completi", "Sgomberi appartamenti", "Sgomberi cantine",
      "Smontaggio mobili", "Montaggio mobili", "Imballaggio", "Trasporto merci",
      "Facchinaggio", "Consegne a domicilio", "Noleggio furgoni con conducente",
      "Piccoli trasporti", "Trasporto oggetti pesanti", "Svuota appartamenti"
    ]
  },
  "Riparazioni e Manutenzione": {
    icon: "🔧",
    skills: [
      "Idraulico", "Elettricista", "Falegname", "Fabbro", "Imbianchino",
      "Piastrellista", "Cartongessista", "Montaggio cucine", "Montaggio mobili IKEA",
      "Riparazione elettrodomestici", "Manutenzione caldaie", "Climatizzazione",
      "Tapparelle e persiane", "Serrature e porte", "Piccole riparazioni casa",
      "Tuttofare", "Manutenzione condomini"
    ]
  }
};

// Permessi di lavoro Svizzera
export const PERMESSI_LAVORO = [
  { value: "svizzero", label: "Cittadino Svizzero", description: "Nazionalità svizzera" },
  { value: "C", label: "Permesso C", description: "Domicilio permanente" },
  { value: "B", label: "Permesso B", description: "Dimora temporanea" },
  { value: "G", label: "Permesso G (Frontaliere)", description: "Lavoratore frontaliero" },
  { value: "L", label: "Permesso L", description: "Dimora breve (< 1 anno)" },
  { value: "N", label: "Permesso N", description: "Richiedente asilo" },
  { value: "F", label: "Permesso F", description: "Ammissione provvisoria" }
];

// Lingue con livelli
export const LINGUE = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "de", label: "Tedesco", flag: "🇩🇪" },
  { code: "fr", label: "Francese", flag: "🇫🇷" },
  { code: "en", label: "Inglese", flag: "🇬🇧" },
  { code: "es", label: "Spagnolo", flag: "🇪🇸" },
  { code: "pt", label: "Portoghese", flag: "🇵🇹" }
];

export const LIVELLI_LINGUA = [
  { value: "base", label: "Base", description: "A1-A2" },
  { value: "medio", label: "Intermedio", description: "B1-B2" },
  { value: "fluente", label: "Fluente", description: "C1-C2" },
  { value: "madrelingua", label: "Madrelingua", description: "" }
];

// Settori aziendali
export const SETTORI_AZIENDALI = [
  "Ristorazione e Hospitality",
  "Edilizia e Costruzioni",
  "Informatica e Tecnologia",
  "Banche e Finanza",
  "Assicurazioni",
  "Lusso e Orologeria",
  "Sanità e Farmaceutica",
  "Logistica e Trasporti",
  "Commercio e Retail",
  "Industria Manifatturiera",
  "Settore Pubblico",
  "Servizi alla Persona",
  "Turismo e Viaggi",
  "Immobiliare",
  "Energia e Utilities",
  "Media e Comunicazione",
  "Consulenza",
  "Legale",
  "Istruzione e Formazione",
  "Altro"
];

export default { SETTORI_SKILLS, PERMESSI_LAVORO, LINGUE, LIVELLI_LINGUA, SETTORI_AZIENDALI };
